import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/playground/"
)({
  beforeLoad({ params }) {
    throw redirect({
      to: "/orgs/$organizationId/projects/$projectId/playground/chat",
      params,
    });
  },
});
